import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AmcLoginHeaderComponent } from './amc-login-header.component';
import { AmcLoginComponent } from './amc-login.component';
import { AuthorizationServiceModule } from '../../../services';
import { CheckboxModule } from '../../../components/base-ui-components/form/checkbox/checkbox.module';
import { InputModule } from '../../../components/base-ui-components/form/input/input.module';
import { ButtonModule } from '../../../components/base-ui-components/button/button.module';
import { TextTooltipModule } from '../../../components/base-ui-components/tooltip/tooltip.module';
import { StaticMsgModule } from '../../../pipes';
import { SignalService } from './signal.service';
import { ThrottleClickDirectiveModule } from '@lib/directives';

@NgModule({
  declarations: [AmcLoginComponent, AmcLoginHeaderComponent],
  providers: [SignalService],
  imports: [
    AuthorizationServiceModule,
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    CheckboxModule,
    InputModule,
    ButtonModule,
    TextTooltipModule,
    StaticMsgModule,
    ThrottleClickDirectiveModule,
  ],
  exports: [AmcLoginComponent, AmcLoginHeaderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AmcLoginModule {}
